import styled from 'styled-components';
import { Tabs } from 'components/Base/Tabs';

export const AllELCsTabs = styled(Tabs)`
  &.ant-tabs {
    .ant-tabs-content-holder {
      padding: 16;
      max-height: calc(100vh - 155px);
      overflow: auto;
    }
  }
`;
